import { render, staticRenderFns } from "./putawayDetail.vue?vue&type=template&id=75ace49a&scoped=true&"
import script from "./putawayDetail.vue?vue&type=script&lang=js&"
export * from "./putawayDetail.vue?vue&type=script&lang=js&"
import style0 from "./putawayDetail.vue?vue&type=style&index=0&id=75ace49a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ace49a",
  null
  
)

export default component.exports